import { reduxForm } from 'redux-form'
import { goBack, replace } from 'react-router-redux'
import get from 'lodash/get'
import { fetchServicing, updateServicing } from '../../actions/servicings'

import ServicingImagesForm from '../../components/servicings/servicing-images-form'

const fields = [
  'beforeAftersAttributes',
]

function mapStateToProps (state, { params: { areaId: servicingId } }) {
  const servicing = get(state, `servicings.${servicingId}`)

  if (!servicing) return { loading: true }

  return {
    servicing,
    modalTitle: 'Before/After Images',
    submitButtonText: 'Save',
    initialValues: {
       beforeAftersAttributes: [
        { beforeImage: { preview: '' }, afterImage: { preview: '' } },
        ...servicing.beforeAfters.map(ba => ({
          id: ba.id,
          time_taken_between: ba.time_taken_between || ba.timeTakenBetween,
          beforeImage: {
            ...(ba.beforeImage || {}),
            preview: (ba.beforeImage && ba.beforeImage.url) || ''
          },
          afterImage: {
            ...(ba.afterImage || {}),
            preview: (ba.afterImage && ba.afterImage.url) || ''
          }
        }))
      ]
    }
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const { areaId: servicingId } = ownProps.params

  dispatch(fetchServicing(servicingId))

  return {
    onSubmit (data) {
      return dispatch(updateServicing(servicingId, data))
        .then(action => action.error && Promise.reject({ _error: action.payload.errors[0] }))
        .then(action => dispatch(goBack()))
    },

    handleClose () {
      dispatch(goBack())
    }
  }
}

export default reduxForm(
  {
    fields,
    form: 'servicingImagesForm'
  },
  mapStateToProps,
  mapDispatchToProps
)(ServicingImagesForm)



// WEBPACK FOOTER //
// ./src/containers/servicings/servicing-images-form-container.js